
export default function () {
  const runtimeConfig = useRuntimeConfig()

  const siteName = computed(() =>
    runtimeConfig.public.source === 'user' ? 'Gigcep' : '360Sosyal',
  )

  return siteName.value
}
